import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
} from "reactstrap";

import { UserApis } from "../../apis/UserApi";
import { useTranslation } from "react-i18next";

const ViewAdminUser = (props) => {
  const { id } = useParams();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { t, i18n } = useTranslation();

  // ✅ Detect RTL language
  const isRTL = i18n.language === "ar";

  useEffect(() => {
    if (!id) return;

    setLoading(true);

    UserApis.getUserById(id)
      .then((res) => {
        console.log("API Response:", res.data);
        setUser(res.data?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching user:", err);
        setError(t("Failed to load user details."));
        setLoading(false);
      });
  }, [id, t]);

  if (loading) {
    return (
      <Container
        className="text-center mt-5"
        dir={isRTL ? "rtl" : "ltr"}
      >
        <Spinner color="primary" />
        <p>{t("Loading user details...")}</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container
        className="text-center mt-5"
        dir={isRTL ? "rtl" : "ltr"}
      >
        <p className="text-danger">{t("Failed to load user details.")}</p>
      </Container>
    );
  }

  if (!user) {
    return (
      <Container
        className="text-center mt-5"
        dir={isRTL ? "rtl" : "ltr"}
      >
        <p>{t("No user found.")}</p>
      </Container>
    );
  }

  return (
    <Container
      className="mt-5"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <Row>
        
        <Col md={{ size: 10, offset: 1 }}> <br /> <br />
          <Card>
            <CardBody className={isRTL ? "text-end" : "text-start"}>
             
              <h3 className="mb-3">{t("User Admin Details")}</h3>

              <hr />

              {/* User ID */}
              <p>
                <strong>{t("User ID")}:</strong>{" "}
                <span dir="ltr">{user.id}</span>
              </p>

              {/* Full Name */}
              <p>
                <strong>{t("Full Name")}:</strong>{" "}
                <span dir="ltr">
                  {[user.firstname, user.lastname]
                    .filter(Boolean)
                    .join(" ")}
                </span>
              </p>

              {/* Email */}
              <p>
                <strong>{t("Email")}:</strong>{" "}
                <span dir="ltr">{user.email || "-"}</span>
              </p>

              {/* Phone */}
              <p>
                <strong>{t("Phone")}:</strong>{" "}
                {user.phone_number ? (
                  <span dir="ltr">
                    +{user.country_phone_code} {user.phone_number}
                  </span>
                ) : (
                  "-"
                )}
              </p>

              {/* Gender */}
              <p>
                <strong>{t("Gender")}:</strong>{" "}
                {user.gender || "-"}
              </p>

              {/* DOB */}
              <p>
                <strong>{t("Date of Birth")}:</strong>{" "}
                <span dir="ltr">
                  {user.date_of_birth || "-"}
                </span>
              </p>

              {/* Specialities */}
              <p>
                <strong>{t("Specialities")}:</strong>{" "}
                {user.specialities || "-"}
              </p>

              {/* Wallet */}
              <p>
                <strong>{t("Wallet Balance")}:</strong>{" "}
                <span dir="ltr">
                  ₹{user.wallet_balance ?? 0}
                </span>
              </p>

              {/* Status */}
              <p>
                <strong>{t("Status")}:</strong>{" "}
                {user.status === 1
                  ? t("Active")
                  : t("Inactive")}
              </p>

              {/* Role */}
              <p>
                <strong>{t("Role")}:</strong>{" "}
                {user.role_name || "-"}
              </p>

              {/* Address */}
              <p>
                <strong>{t("Address")}:</strong>{" "}
                {user.address || "-"}
              </p>

            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ViewAdminUser;